module.exports = __webpack_public_path__ + "static/media/front.309629a4.jpg";